<template>
  <div>
    <v-container grid-list-md class="pa-0" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            background-color="white"
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadActiveCompData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    append-icon="search"
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading" class="blackbox-loader"></div>
  
    <v-card v-if="!loading && companies.length > 1" >
      <v-container grid-list-md fluid class="ma-0 pa-1">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md3 xs6>
            <v-btn :color="todaySelected.color" darken :loading="todaySelected.loading" @click="filterConversionToday()" style="margin: 0; height: 48px;" block large><span :style="{color: todaySelected.textColor}">Vandaag</span></v-btn>
          </v-flex>
          <v-flex md3 xs6>
            <v-btn :color="weekSelected.color"  :loading="weekSelected.loading" @click="filterConversionWeek()" style="margin: 0; height: 48px;" block large><span :style="{color: weekSelected.textColor}">Deze week</span></v-btn>
          </v-flex>
          <v-flex md3 xs6>
            <v-btn :color="monthSelected.color" :loading="monthSelected.loading" @click="filterConversionMonth()" style="margin: 0; height: 48px;" block large><span :style="{color: monthSelected.textColor}">Deze maand</span></v-btn>
          </v-flex>
          <v-flex md3 xs6>
            <v-btn :color="periodSelected.color" :loading="periodSelected.loading" @click="filterConversionPeriod()" style="margin: 0; height: 48px;" block large><span :style="{color: periodSelected.textColor}">Selecteer maand</span></v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="filterPeriod" row wrap class="ma-0 pa-0">
          <v-flex md3 xs12>
            <v-select
              :color="companyPrimaryColor"
              :items="activeYears"
              label="Selecteer jaar"
              hide-details
              solo
              v-model="selectedPeriodYear"      
            ></v-select>
          </v-flex>
          <v-flex md6 xs12>
            <v-select
              :color="companySecondaryColor"
              :items="months"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              label="Selecteer maand"
              hide-details
              v-model="selectedPeriodMonth"
              solo
            ></v-select>
          </v-flex>
          <v-flex md3 xs12>
            <v-btn @click="loadCustomPeriodFilter(selectedPeriodMonth, selectedPeriodYear, 'filter')" :disabled="filterButtonDisabled" :depressed="filterButtonDisabled" :color="companySecondaryColor" style="margin: 0; height: 48px;" large block><span style="color:#fff;">Filter</span></v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <div v-if="!loading && dataLoading">
      <div class="loading-dots">
        <div class="loading-dots-loader"></div>
        <p class="loading-dots-text"></p>
      </div>
    </div>

    <v-card style="margin: 20px 0" v-if="!loading && !dataLoading" >
      <div class="conversion-selected-period">
        <p v-if="conversionPeriodType == 'day'"> <strong>{{ conversionPeriodStart }}</strong></p>
        <p v-else><strong>{{ conversionPeriodStart }}</strong> t/m <strong>{{ conversionPeriodEnd }}</strong></p>
      </div>
      <div class="query-filter">
        <v-select
          v-if="conversions.length > 0"
          v-model="selectedSources"
          :items="sources"
          item-text="name"
          item-value="query"
          label="Selecteer campagne bronnen"
          multiple
          single-line
          hide-details
          box
        >
          <template v-slot:selection="{ item, index }">
            <v-chip :color="item.bgColor.hex" v-if="index === 0">
              <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
            </v-chip>
            <v-chip :color="item.bgColor.hex" v-if="index === 1">
              <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
            </v-chip>
            <v-chip :color="item.bgColor.hex" v-if="index === 2">
              <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
            </v-chip>
            <v-chip :color="item.bgColor.hex" v-if="index === 3">
              <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
            </v-chip>
            <v-chip :color="item.bgColor.hex" v-if="index === 4">
              <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
            </v-chip>
            <v-chip :color="item.bgColor.hex" v-if="index === 5">
              <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
            </v-chip>
            <v-chip :color="item.bgColor.hex" v-if="index === 6">
              <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
            </v-chip>
            <span
              v-if="index === 7"
              class="grey--text caption"
            >(+{{ selectedSources.length - 7 }} andere)</span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile
              ripple
              @click="toggle"
            >
              <v-list-tile-action>
                <v-icon :color="selectedSources.length > 0 ? companyPrimaryColor : ''">{{ icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecteer alles</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:append-item>
            <v-divider class="mb-2"></v-divider>
            <v-list-tile disabled>
              <v-list-tile-avatar color="grey lighten-3">
                <v-icon>local_atm</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content v-if="chooseAllSources">
                <v-list-tile-title>Iemand hier wil alles weten over conversies ;)</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-content v-else-if="selectSomeSources">
                <v-list-tile-title>Conversie tags</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedSources.length }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-content v-else>
                <v-list-tile-title>
                  Geen interesse in conversies?
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  Kom op, selecteer tags hierboven.
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-select>
      </div>
      
      <div class="no-conversions" v-if="conversionsFiltered.length == 0">
        <div class="hipster-image" :class="randomHipster"></div>
        <p>Geen conversies gevonden.</p>
      </div>
      <div v-else>
        <v-container class=" ma-0 pa-1" grid-list-md fluid>
          <v-layout row wrap class="ma-0 pa-0">
            <!--  <v-flex xs12>
              <v-card  style="padding: 10px; box-shadow: none; background-color: #f9f9f9;">
                <v-sheet class="ma-0" elevation="0">
                  <v-sparkline
                    :value="conversionTableValues"
                    :labels="conversionTableLabels"

                    line-width="2"
                    :gradient="[companyPrimaryColor, companySecondaryColor]"
                    :color="companyPrimaryColor"
                    stroke-linecap="round"
                    height="100"
                    padding="10"
                    label-size="2"
                  >
              
                  </v-sparkline>
                </v-sheet>
              </v-card> 
            </v-flex> -->
            <v-flex md4 xs6>
              <v-card class="usertype-total" style="box-shadow: none; background-color: #f9f9f9;">
                <div class="usertype-total-number">{{ conversionsFiltered.length }}</div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template slot="activator">
                      <span v-if="conversions == 1">Intentie <v-icon small color="#ccc" slot="activator">help</v-icon></span>
                      <span v-else>Intenties <v-icon small color="#ccc" slot="activator">help</v-icon></span>
                    </template>
                    <span style="color: #fff">Aantal pogingen die gestart zijn om een conversie te doen.</span>
                  </v-tooltip>     
                </div>
              </v-card>
            </v-flex>
            <v-flex md4 xs6>
              <v-card class="usertype-total" style="box-shadow: none; background-color: #f9f9f9;">
                <div class="usertype-total-number">{{ conversionsSuccessRate }}%</div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template slot="activator">
                      <span>Succesvol <v-icon small color="#ccc" slot="activator">help</v-icon></span>   
                    </template>
                    <span style="color: #fff">Het percentage dat succesvol is afgerond.</span>
                  </v-tooltip>             
                </div>
              </v-card>
            </v-flex>
            <v-flex md4 xs6>
              <v-card class="usertype-total" style="box-shadow: none; background-color: #f9f9f9;">
                <div class="usertype-total-number">&euro; {{ conversionsValue }}</div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template slot="activator">
                      <span>Waarde <v-icon small color="#ccc" slot="activator">help</v-icon></span>   
                    </template>
                    <span style="color: #fff">Waarde van de conversies in geld.</span>
                  </v-tooltip>
                                
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-data-table
          :headers="headers"
          :items="conversionsFiltered"
          :pagination.sync="pagination"
          hide-actions
          >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.timestamp.seconds | moment("DD-MM-YYYY H:mm")}}u</td>
            <td> {{ props.item.clientData.name }}</td>
            <td>
              <span v-for="(type, index) in types" :key="index">
                <span v-if="props.item.type == type.id">{{type.name}}</span>
              </span>
            </td>
            <td>
              <span v-if="props.item.source">
                <span v-for="(source, index) in sources" :key="index">
                  <span style="padding: 5px;" :style="{color: source.textColor.hex, backgroundColor: source.bgColor.hex}" v-if="props.item.source == source.query">{{source.name}}</span>
                </span>
              </span>
              <span v-else>Bron onbekend</span>
            </td>

            <td>
              <span v-if="props.item.value"> 
                <span v-if="props.item.value.type == 'amount'"> &euro;</span> {{ props.item.value.number }}
              </span>
            </td>
            <td>
              <span v-if="props.item.progress.completed" style="padding: 3px; display: block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span>
              <span v-else style="padding: 5px; background-color: #ff9800; display: block; width: 60px; text-align: center;">Nee</span>
            </td>
            <td>
              <v-layout justify-space-around>
                <v-icon small color="#c1c1c1">phone</v-icon>
                <v-icon small color="#c1c1c1">email</v-icon>
              </v-layout>
            </td>
            
            <td>
              <v-icon v-if="!props.expanded" @click="props.expanded = !props.expanded">arrow_drop_down</v-icon>
              <v-icon :color="companyPrimaryColor" v-if="props.expanded == true" @click="props.expanded = !props.expanded">arrow_drop_up</v-icon>
            </td>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-card-text>
                <v-container class="extra-conversion-info ma-0 pa-0" grid-list-md fluid>
                  <v-layout row wrap class="ma-0 pa-0">
                    <v-flex md4 xs6>
                      <div class="conversion-client-info">
                        <h3>Contactgegevens</h3>
                        <p><span class="info-label">Naam:</span> <span v-if="props.item.clientData.name"> {{ props.item.clientData.name }}</span><span v-else> - </span></p>
                        <p><span class="info-label">Telefoon:</span> <span  v-if="props.item.clientData.phone">{{ props.item.clientData.phone }}</span><span v-else> - </span></p>
                        <p><span class="info-label">Email:</span> <span  v-if="props.item.clientData.email">{{ props.item.clientData.email }}</span><span v-else> - </span></p>
                        <p><span class="info-label">IP-adres:</span> <span  v-if="props.item.clientData.ip">{{ props.item.clientData.ip }}</span><span v-else> - </span></p>
                      </div>
                    </v-flex>
                    <v-flex md4 xs6>
                      <div v-if="props.item.type== 'salonhub'" class="conversion-client-info">
                        <h3>Afspraak gegevens</h3>
                        <p><span class="info-label">Nieuwe klant:</span> <span v-if="props.item.salonhubData.existingClient == true">Nee</span><span v-else-if="props.item.salonhubData.existingClient == false">Ja <v-icon color="warning" small>warning</v-icon></span><span v-else> - </span></p>                            
                        <p><span class="info-label">Vestiging:</span> <span v-if="props.item.salonhubData.branch">{{ props.item.salonhubData.branch }}</span><span v-else> - </span></p>
                        <p><span class="info-label">Datum:</span> <span v-if="props.item.salonhubData.steps.date">{{ props.item.salonhubData.steps.date.seconds | moment("DD-MM-YYYY") }}</span><span v-else> - </span></p>
                        <p><span class="info-label">Geslacht:</span> <span v-if="props.item.salonhubData.steps.gender.name">{{ props.item.salonhubData.steps.gender.name }}</span><span v-else> - </span></p>
                        <p><span class="info-label">Behandeling:</span> <span v-if="props.item.salonhubData.steps.treatment.name">{{ props.item.salonhubData.steps.treatment.name }}</span><span v-else> - </span></p>
                        <p><span class="info-label">Medewerker:</span> <span v-if="props.item.salonhubData.steps.employee.name">{{ props.item.salonhubData.steps.employee.name }}</span><span v-else> - </span></p>
                      </div>
                    </v-flex>
                    <v-flex md4 xs6>
                      <div class="conversion-client-info">
                        <h3>Voortgang</h3>
                        <p v-if="props.item.progress.completed"><span class="info-label">Afgerond:</span> Ja</p>
                        <p v-if="!props.item.progress.completed"><span class="info-label">Afgerond:</span> Nee</p>
                        <p><span class="info-label">Afgerond door:</span>
                          <span v-if="props.item.progress.completed && props.item.progress.completedBy == 'user'">Klant</span>
                          <span v-else-if="props.item.progress.completed && props.item.progress.completedBy != 'user'">{{ props.item.progress.completedBy }} </span>
                          <span v-else> - </span>
                        </p>
                        <p><span class="info-label">Afgerond op:</span> <span v-if="props.item.progress.completedOn">{{ props.item.progress.completedOn.seconds | moment("DD-MM-YYYY") }}</span> <span v-else> - </span></p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
        
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>

      </div>
    </v-card>
  </div>
</template>

<script>

import { bus } from "../main";
import db from "../firebase/init";
import platform from 'platform'; 

export default {
  name: "WidgetStats",
  props: ["urlStart", "urlEnd"],

  data: () => ({
    loading: true,
    feedback: null,
    filterToday: true,
    filterWeek: false,
    filterMonth: false,
    filterPeriod: false,
    selectedPeriodDay: "01",
    selectedPeriodYear: moment().year(),
    selectedPeriodMonth: Number(moment().format("M")),
    activeCompData: {},
    conversions: [],
    activeCompDataOriginal: {},
    companies: [],
    branches: [],
    activeComp: "", 
    compStartYear: null,
    compStartMonth: null, 
    dataLoading: false,
    toggle_exclusive: 1,
    today: null,
    conversionPeriodType: 'day',
    conversionPeriodStart: null,
    conversionPeriodEnd: null,
    currentMonth: Number(moment().format("M")),
    selectedSources: [],
    conversionTableLabels: [],
    types: [
      {
        id: 'salonhub',
        name: 'Salonhub'
      },
      {
        id: 'wordpressForm',
        name: 'Wordpress Formulier'
      }
    ],
    sources: [
      {
        query: 'nosource',
        name: 'Geen',
        bgColor: {
          hex: '#cecece'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'unknown',
        name: 'Onbekend',
        bgColor: {
          hex: '#ccc'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'mc',
        name: 'Mailchimp',
        bgColor: {
          hex: '#ffe01b'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'adw',
        name: 'Adwords',
        bgColor: {
          hex: '#1a73e8'
        },
        textColor: {
          hex: '#fff'
        }
      }
    ],
    pagination: {
      sortBy: "timestamp.seconds",
      rowsPerPage: -1,
      descending: true
    },
    headers: [
      {
        text: "Datum",
        align: "left",
        value: "timestamp.seconds",
        width: "170px"
      },
      {
        text: "Naam",
        align: "left",
        value: "clientData.name"
      },
      {
        text: "Type",
        align: "left",
        value: "type"
      },
      {
        text: "Bron",
        align: "left",
        value: "source"
      },
      {
        text: "Waarde",
        align: "left",
        value: "value.number"
      },
      {
        text: "Afgerond",
        align: "left",
        value: "progress.completed"
      },
      {
        text: "",
        align: "left",
        width: "100px"
      },
      {
        text: "",
        align: "right",
        width: "80px"
      }
    ],
    conversionTableValuesTest: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240
      ],
    conversionTableLabelsTest: [
        '12am',
        '3am',
        '6am',
        '9am',
        '12pm',
        '3pm',
        '6pm',
        '9pm'
      ]
  
  }),

  created() {
    console.log("created Triggered")
    this.loadUserComp();
    this.today = moment().unix()
  },

  methods: {
     loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
            if(doc.data().conversion.start){
              this.compStartYear = moment.unix(doc.data().conversion.start.seconds).format("YYYY")
              this.compStartMonth = moment.unix(doc.data().conversion.start.seconds).format("M")
            } else {
              this.compStartYear = moment().year()
              this.compStartMonth = moment().month()
            }
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
        })
        .then(()=>{
          if(this.activeCompData.conversion.sources.length > 0){
            this.activeCompData.conversion.sources.forEach(sourceItem=>{
              this.sources.push(sourceItem)
            })
          }
        })
        .then(() => {
          this.selectAllSources()
          this.loading = false;
          this.dataLoading = true;

          if(this.urlStart && this.urlEnd){
            // Url params aanwezig
            let currentDay = moment().startOf('day').format("YYYY-MM-DD")
            let startCurrentWeek = moment().weekday(0).format("YYYY-MM-DD")
            let endCurrentWeek = moment().weekday(7).format("YYYY-MM-DD")          
            let startCurrentMonth = moment().startOf('month').format("YYYY-MM-DD")
            let endCurrentMonth = moment().endOf('month').format("YYYY-MM-DD")

            if(this.urlStart == currentDay && this.urlEnd == currentDay){
              this.filterConversionToday()
            } else if(this.urlStart == startCurrentWeek && this.urlEnd == endCurrentWeek){
              this.filterConversionWeek()
            } else if(this.urlStart == startCurrentMonth && this.urlEnd == endCurrentMonth){
              this.filterConversionMonth()
            } else {
              this.filterToday = false;
              this.filterWeek = false;
              this.filterMonth = false;
              this.filterPeriod = false;
              this.loadCustomPeriodFilter(this.urlStart, this.urlEnd, 'url')
            }

          }
          // else if(this.conversionPeriodStart && this.conversionPeriodEnd){
          //   // Geselecteerde dat
          // }
          else {
            this.filterConversionToday()
          }  
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

    selectAllSources(){
      this.selectedSources = []
      this.sources.forEach(source => {
        this.selectedSources.push(source.query)
      })
    },

    toggle () {
      this.$nextTick(() => {
        if(this.chooseAllSources) {
          this.selectedSources = []
        } else {
          this.selectAllSources()
        }
      })
    },

    filterConversionToday(){
      console.log("Get conversions today")
      this.filterToday = true;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().startOf('day').format("YYYY-MM-DD")
      let lastDate = moment().endOf('day').add(1, 'day').format("YYYY-MM-DD")
  
      this.loadConversionDate(firstDate, lastDate, 'day')
    },

    filterConversionWeek(){
      this.filterToday = false;
      this.filterWeek = true;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().weekday(0).format("YYYY-MM-DD")
      let lastDate = moment().weekday(7).add(1, 'day').format("YYYY-MM-DD")
  
      this.loadConversionDate(firstDate, lastDate, 'week')
    },

    filterConversionMonth(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = true;
      this.filterPeriod = false;
      let firstDate = moment().startOf('month').format("YYYY-MM-DD")
      let lastDate = moment().endOf('month').add(1, 'day').format("YYYY-MM-DD")

      this.loadConversionDate(firstDate, lastDate, 'month')
    },

    filterConversionPeriod(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = true;
    },

    loadCustomPeriodFilter(start, end, filter){
      if(filter == 'url'){
        this.loadConversionDate(start, end, 'month')
      } else {
        this.selectedPeriodDay = '01'
        let selectedDate = this.selectedPeriodYear+"-"+this.selectedPeriodMonth+"-01"
        let firstDate = moment(selectedDate).startOf('month').format("YYYY-MM-DD")
        let lastDate = moment(selectedDate).endOf('month').add(1, 'day').format("YYYY-MM-DD")
        this.loadConversionDate(firstDate, lastDate, 'month')
      }
    },

    loadConversionDate(firstDate, lastDate, type){
      this.dataLoading = true;
      this.conversions = []
      let start = new Date(firstDate)
      let end = new Date(lastDate)

      this.conversionPeriodType =  type,
      this.conversionPeriodStart = moment(firstDate).format("D MMMM YYYY")
      this.conversionPeriodEnd = moment(lastDate).format("D MMMM YYYY")

      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?start=' + firstDate+ '&end=' + lastDate;
        window.history.pushState({path:newurl},'',newurl);
      }

      let numberOfDays = moment(lastDate).diff(firstDate, 'days', false) + 1;
      this.conversionTableLabels = Array.apply(null, Array(numberOfDays))
      let counter = 0

      this.conversionTableLabels.forEach((year, index)=>{
        this.conversionTableLabels[index] = moment(firstDate).add(counter, 'days').format("D MMM")
        counter++
      })

      

      // this.$router.push({ path: "widget-statistieken", query: {start: firstDate, end: lastDate}, silent: true })  
      db.collection("conversion")
        .where("companyId", "==", this.activeCompData.id)
        .where("timestamp", ">=", start)
        .where("timestamp", "<=", end)
        .orderBy("timestamp")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let conversion = doc.data()
            conversion.id = doc.id
            let source = _.find(this.sources, { 'query': conversion.source});
            
            if(!doc.data().source){
              conversion.source = 'nosource'
            }
            if(doc.data().source && !source){
              conversion.source = 'unknown'
            }
            this.conversions.push(conversion)
          })
        })
        .then(()=>{
          this.dataLoading = false;
        })
        .catch(error=>{
          this.dataLoading = false;
          console.error("Laden van conversies is niet gelukt: ", error)
        })
    }
  },

  computed: {

    conversionTableValues(){
      let data = Array.apply(null, Array(this.conversionTableLabels.length))

      this.conversionTableLabels.forEach((day, index) =>{
        data[index] = 0
        let dayDate = moment(this.conversionPeriodStart).add(index, 'days').format('YYYY-MM-DD')
          this.conversionsFiltered.forEach(conversion =>{
            if(moment.unix(conversion.timestamp.seconds).format('YYYY-MM-DD') == dayDate){
              data[index]++
            }
          })
      })
      return data
    },

    chooseAllSources () {
      return this.selectedSources.length === this.sources.length
    },
    selectSomeSources () {
      return this.selectedSources.length > 0 && !this.chooseAllSources
    },

    icon () {
      if(this.chooseAllSources) return 'check_box'
      if(this.selectSomeSources) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },

    conversionsFiltered(){
      let filterdConversions = []
      if(this.conversions.length > 0){
        this.conversions.forEach(conversion=>{  
          let source = _.indexOf(this.selectedSources, conversion.source);
          if(source >= 0){
            filterdConversions.push(conversion)
          }
        })
        return filterdConversions
      } 
      else {
        return filterdConversions
      }
    },

    conversionsSuccessRate(){
      let successCounter = 0
      let succesRate = 0

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.progress && conversion.progress.completed){
            successCounter++
          }
        })
      }

      succesRate = (successCounter / this.conversionsFiltered.length * 100).toFixed(0)
      return succesRate
    },

    conversionsValue(){
      let successValue = 0
      let value = 0

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.progress && conversion.progress.completed && conversion.value && conversion.value.type == 'amount'){
            successValue = successValue + conversion.value.number
          }
        })
      }
      value = successValue.toFixed(2)
      return value
    },

    activeYears(){
      let currentYear = Number(moment().year())
      let startDateCompany = moment().format("YYYY-MM-DD")

      if(this.activeCompData.conversion.start){
        startDateCompany = moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY-MM-DD")
      }

      let numberOfYears = moment().diff(startDateCompany, 'years', false) + 2;
      let activeYears = Array.apply(null, Array(numberOfYears))
      let counter = 0

      activeYears.forEach((year, index)=>{
        activeYears[index] = currentYear - counter
        counter++
      })
      return activeYears
    },

    months(){
      let months = [
        { id: 1, name: "Januari", disabled: false },
        { id: 2, name: "Februari", disabled: false },
        { id: 3, name: "Maart", disabled: false },
        { id: 4, name: "April", disabled: false },
        { id: 5, name: "Mei", disabled: false },
        { id: 6, name: "Juni", disabled: false },
        { id: 7, name: "Juli", disabled: false },
        { id: 8, name: "Augustus", disabled: false },
        { id: 9, name: "September", disabled: false },
        { id: 10, name: "Oktober", disabled: false },
        { id: 11, name: "November", disabled: false },
        { id: 12, name: "December", disabled: false },  
      ]

      if(this.selectedPeriodYear == moment().year()){
        months.forEach(month=>{
          if(month.id > this.currentMonth){
            month.disabled = true
          } 
        })
        return months
      }
      else if(this.selectedPeriodYear == this.compStartYear){
        months.forEach(month=>{
          if(month.id < this.compStartMonth){
            month.disabled = true
          } 
        })
        return months
      } else{
        return months
      }
    },

    filterButtonDisabled(){
      if((this.selectedPeriodYear == moment().year() && this.currentMonth < this.selectedPeriodMonth) || this.selectedPeriodYear == this.compStartYear && this.selectedPeriodMonth < this.compStartMonth){
        return true
      } else {
        return false
      }
    },

    todaySelected(){
      let data = {
        color: "#e1e1e1",
        textColor: "#333",
        loading: false
      }
      if(this.filterToday && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterToday){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    weekSelected(){
      let data = {
        color: "#e1e1e1",
        textColor: "#333",
        loading: false
      }
      if(this.filterWeek && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterWeek){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    monthSelected(){
      let data = {
        color: "#e1e1e1",
        textColor: "#333",
        loading: false
      }
      if(this.filterMonth && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterMonth){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    periodSelected(){
      let data = {
        color: "#e1e1e1",
        textColor: "#333",
        loading: false
      }
      if(this.filterPeriod && this.dataLoading){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterPeriod){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
      } 
      return data
    },

    randomHipster(){
      if(this.conversionsFiltered.length == 0){
        let randomNumber = Math.floor(Math.random() * 12) + 1;
        let hipsterClass = "hipster-" + randomNumber
         return hipsterClass
      } else {
        return null
      }    
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },

    changed() {
      if (_.isEqual(this.activeCompData, this.activeCompDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style >

.extra-conversion-info h3{
  padding: 0 0 10px 0;
}

.conversion-client-info .info-label{
  font-weight: 600;
  width: 120px;
  display: inline-block;
}

.no-conversions{
  width: 280px;
  margin: 0px auto;
  padding: 80px 0;
}

.hipster-image{
  width: 130px;
  height: 130px;
  margin: 0 auto;
}

.no-conversions p{
  font-weight: 600;
  text-align: center;
  font-size: 16px;
}

.hipster-1{
  background: url('../assets/hipsters/hipster-1.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-2{
  background: url('../assets/hipsters/hipster-2.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-3{
  background: url('../assets/hipsters/hipster-3.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-4{
  background: url('../assets/hipsters/hipster-4.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-5{
  background: url('../assets/hipsters/hipster-5.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-6{
  background: url('../assets/hipsters/hipster-6.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-7{
  background: url('../assets/hipsters/hipster-7.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-8{
  background: url('../assets/hipsters/hipster-8.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-9{
  background: url('../assets/hipsters/hipster-9.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-10{
  background: url('../assets/hipsters/hipster-10.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-11{
  background: url('../assets/hipsters/hipster-11.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-12{
  background: url('../assets/hipsters/hipster-12.png') no-repeat center center;
  background-size: 110px auto;
}

.conversion-selected-period p {
  text-align: center;
  padding: 15px 0 5px 0;
  text-transform: lowercase;
}

 .v-toolbar.custom-toolbar .v-toolbar__content, 
 .v-toolbar.custom-toolbar .v-toolbar__extension{
   padding: 0!important;
 }
 .query-filter{
   padding: 10px;
 }
</style>
